<template>
  <div>
    <div style="position: sticky; top: 64px; z-index: 1">
      <v-row
        no-gutters
        class="grey lighten-4"
        style="border-bottom: 1px solid"
      >
        <v-col class="pa-4">
          <slot name="title" />
        </v-col>
        <v-col
          cols="9"
          class="pr-3"
        >
          <v-row
            no-gutters
            class="fill-height"
          >
            <v-col
              v-for="hour in hours"
              :key="hour"
              class="caption text--secondary fill-height"
              style="position: relative"
            >
              <!--<editor-fold desc="Full hour tick">-->
              <div style="position: absolute; border-left: 1px solid; height: 12px; bottom: 0" />
              <!--</editor-fold>-->
              <div
                v-if="hour === 23"
                style="position: absolute; border-right: 1px solid; height: 12px; width: 100%; bottom: 0"
              />
              <div
                style="position: absolute; bottom: 12px; transform: translateX(-40%)"
                class="caption text--secondary"
              >
                {{ hour }}
              </div>
              <div
                v-if="hour === 23"
                style="position: absolute; bottom: 12px; transform: translateX(50%); right: 0"
                class="caption text--secondary"
              >
                {{ hour + 1 }}
              </div>
              <!--<editor-fold desc="Half hour tick">-->
              <div style="position: absolute; left: 50%; border-left: 1px solid; height: 5px; bottom: 0" />
              <!--</editor-fold>-->
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
name: 'TimelineHolder',
  created() {
    this.hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
  }
}
</script>

<style scoped>

</style>
